import { render, staticRenderFns } from "./AuthProvidersLogin.vue?vue&type=template&id=bf555fbc"
import script from "./AuthProvidersLogin.vue?vue&type=script&lang=js"
export * from "./AuthProvidersLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports